import React, { useState } from "react";
import { Table } from "antd";

const styles = {
  container: { display: "flex", marginTop: "33px" },
  block: { width: "630px", height: "500px", border: "1px solid #CCDDEE" },
  blockTitle: { color: "rgba(93, 108, 122, 1)", marginBottom: "9px" },
  rightBlock: { marginLeft: "32px" },
  dsc: { padding: "13px" },
};

function PermissionsDescription(props) {
  const { permissions } = props;
  const [permissionDsc, setPermissionDsc] = useState("");

  const columns = [
    {
      title: "Привилегии",
      dataIndex: "alias",
      key: "alias",
    },
  ];

  const data = permissions.map((item) => ({
    key: item.id,
    alias: item.alias,
    dsc: item.dsc,
  }));

  return (
    <div style={styles.container}>
      <div>
        <div style={styles.blockTitle}>Привилегии</div>
        <Table
          sticky
          pagination={false}
          size="small"
          columns={columns}
          dataSource={data}
          showHeader={false}
          scroll={{ y: 500 }}
          onRow={(record) => ({
            onClick: () => {
              setPermissionDsc(record.dsc);
            },
          })}
          style={styles.block}
        />
      </div>
      <div style={styles.rightBlock}>
        <div style={styles.blockTitle}>Привилегии</div>
        <div style={styles.block}>
          <p style={styles.dsc}>{permissionDsc}</p>
        </div>
      </div>
    </div>
  );
}

export default PermissionsDescription;
